import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import Link from 'components/Link';
import RepliesListLoading from 'components/RepliesListLoading';
import MailThreadMessageEditor from './MailThreadMessageEditor'; // eslint-disable-line import/no-named-as-default
import MailThreadMessagesListPageSelector from './MailThreadMessagesListPageSelector';
import RepliesList from 'components/RepliesList';
import RepliesListContentMain from 'components/RepliesList/RepliesListContentMain';
import RepliesListContentSticky from 'components/RepliesList/RepliesListContentSticky';
import MailThreadMessage from './MailThreadMessage';
import * as actions from 'actions';
import { getMailThreadMessages, getMailPaging, getTimeLastRefresh } from 'selectors';
import './style.scss';
import { MailThreadMessageShape } from 'entities';
import { actionCausedByURLChangeFrom } from 'utils/actions';

export class MailThreadMessagesList extends Component {

  componentDidMount() {
    this.props.onFetchCurrentPage();
  }

  render() {
    const { totalCount, params, mailThreadMessages, isFetching, pagesCount } = this.props;
    return (
      <RepliesList>
        <RepliesListContentMain>
          <div className="wrapper-full">
            <Link to="/messages" iconName="back">{__('members.mail.messagesList.back')}</Link>
            {(() => {
              if(totalCount > 0) {
                return <span className="float-right">{`${totalCount} messages`}</span>;
              }
            })()}

            <MailThreadMessageEditor threadId={params.id} placeholder={__('members.mail.textEditor.subjectPlaceholder')} />
          </div>

          <div className="wrapper-full is-small-collapsed">
            {(() => {
              if(mailThreadMessages.length > 0) {
                return (
                  <ul>
                    {mailThreadMessages.map(mailThreadMessage => (
                      <MailThreadMessage
                        key={mailThreadMessage.id}
                        threadId={params.id}
                        mailThreadMessage={mailThreadMessage}
                      />
                    ))}
                  </ul>
                );
              }
              else if(isFetching) {
                return <RepliesListLoading />;
              }
            })()}
          </div>
        </RepliesListContentMain>

        {(() => {
          if(pagesCount > 1) {
            return (
              <RepliesListContentSticky>
                <MailThreadMessagesListPageSelector threadId={params.id} />
              </RepliesListContentSticky>
            );
          }
        })()}
      </RepliesList>
    );
  }
}

MailThreadMessagesList.propTypes = {
  mailThreadMessages: PropTypes.arrayOf(MailThreadMessageShape),
  isFetching: PropTypes.bool,
  pagesCount: PropTypes.number,
  totalCount: PropTypes.number,
  onFetchCurrentPage: PropTypes.func,
  params: PropTypes.object,
  lastRefresh: PropTypes.object
};

const mapStateToProps = (state, props) => {
  const { page, pagesCount, isFetching, totalCount } = getMailPaging(state, 'mailThreadMessages', {threadId: props.params.id});

	return {
    mailThreadMessages: getMailThreadMessages(state, {threadId: props.params.id, page}),
    lastRefresh: getTimeLastRefresh(state),
    isFetching,
    pagesCount,
    totalCount
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onFetchCurrentPage: () => {
      dispatch(actionCausedByURLChangeFrom(actions.mailThreadMessagesFetch(props.params.id)));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MailThreadMessagesList);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Mail/MailThreadMessagesList/index.js
 **/